import isExperienceEditor from '@utils/is-experience-editor';

(function() {
    if ($('[data-slider="articleCard"]').length <= 0) {
        return;
    }

    var articleCardSlider = function() {
        var ui = {};

        function cacheUI() {
            ui.$body = $('body');
            ui.$articleCard = $('[data-slider="articleCard"]');
        }

        function initarticleCardSlider(e) {
            ui.$articleCard.each(function(index, element) {
                let newSlidesToShow = 2.75;
                if (element.hasAttribute('data-slidesToShow')) {
                    newSlidesToShow = parseInt(
                        $(element).attr('data-slidesToShow')
                    );
                }

                if (newSlidesToShow == 2.75) {
                    $(element).addClass('-margin-offset');
                }

                let mobileNewSlidesToShow = 1.3;
                if (element.hasAttribute('data-mobileSlidesToShow')) {
                    mobileNewSlidesToShow = parseFloat(
                        $(element).attr('data-mobileSlidesToShow')
                    );
                }

                let showDots = false;
                if (element.hasAttribute('data-showDots')) {
                    if (element.dataset.showdots == 'true') {
                        showDots = true;
                    }
                }

                let infiniteScroll = false;
                if (element.hasAttribute('data-infiniteScroll')) {
                    if (element.dataset.infinitescroll == 'true') {
                        infiniteScroll = true;
                    }
                }

                $(this).addClass('js-articleCard-slider' + index);
                var item_length = $('.js-articleCard-slider' + index + ' > div')
                    .length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-articleCard-slider' + index).slick({
                        autoplay: false,
                        infinite: infiniteScroll,
                        arrows: true,
                        dots: false,
                        slidesToShow: newSlidesToShow,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        rows: 0, // Fix vor v1.8.0-1
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: showDots,
                                },
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: mobileNewSlidesToShow,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: showDots,
                                },
                            },
                        ],
                    });
                }
            });

            ui.$articleCard.addClass('initialize');
        }

        function init() {
            cacheUI();
            initarticleCardSlider();
        }

        return {
            init: init,
        };
    };

    var articleCardSlider = articleCardSlider();
    articleCardSlider.init();
})(window);
